import supportIcon from 'src/public/img/icon-support-type-live.svg';
import meditationIcon from 'src/public/img/meditation-image-page.png';
import undrawFocusIcon from 'src/public/img/undraw-focus-sey-6.svg';
import undrawStudyingIcon from 'src/public/img/undraw-studying-s-3-l-7.svg';
import undrawEventsIcon from 'src/public/img/undraw_events_2p66.svg';
import undrawLostIcon from 'src/public/img/undraw_lost_bqr2.svg';
import undrawMindfulnessIcon from 'src/public/img/undraw_mindfulness_scgo.svg';
import undrawThoughtsIcon from 'src/public/img/undraw_thoughts_e49y.svg';
import undrawTimeIcon from 'src/public/img/undraw_time_management_30iu.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CPProgramStepProps } from '../../models/cpProgram';
import { CPProgramSharedStep } from '../../weekShared/models/weekShared';
import { MindfulnessExerciseStep } from '../stepComponents/MindfulnessExerciseStep';
import { MindfulnessFAQStep } from '../stepComponents/MindfulnessFAQStep';
import { MindfulnessImprovementsTopicsStep } from '../stepComponents/MindfulnessImprovementsTopicsStep';
import { MindfulnessTipsWeekOneStep } from '../stepComponents/MindfulnessTipsWeekOneStep';
import { ProgramOverviewStep } from '../stepComponents/ProgramOverviewStep';
import { WhatDoesMindfulnessDoStep } from '../stepComponents/WhatDoesMindfulnessDoStep';
import { WhatIsMindfulnessStep } from '../stepComponents/WhatIsMindfulnessStep';
import { CPProgramWeekOneStep } from './weekOne';

const steps: (ProgramSharedStep | CPProgramSharedStep | CPProgramWeekOneStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.ProgramOverviewStep,
    CPProgramSharedStep.CorePillarsCheckInStep,
    CPProgramWeekOneStep.WhatIsMindfulnessStep,
    CPProgramWeekOneStep.WhatDoesMindfulnessDoStep,
    CPProgramWeekOneStep.MindfulnessFAQStep,
    CPProgramWeekOneStep.MindfulnessImprovementsTopicsStep,
    CPProgramWeekOneStep.MindfulnessExerciseStep,
    CPProgramSharedStep.MindfulnessTipsStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CPProgramStepProps[] = [
    {
        id: ProgramSharedStep.ProgramOverviewStep,
        component: ProgramOverviewStep,
        tooltip: 'Introduction to Mindfulness',
    },
    {
        id: CPProgramWeekOneStep.WhatIsMindfulnessStep,
        component: WhatIsMindfulnessStep,
        tooltip: 'What is Mindfulness?',
    },
    {
        id: CPProgramWeekOneStep.WhatDoesMindfulnessDoStep,
        component: WhatDoesMindfulnessDoStep,
        tooltip: 'What does Mindfulness do?',
    },
    {
        id: CPProgramWeekOneStep.MindfulnessFAQStep,
        component: MindfulnessFAQStep,
        tooltip: 'Mindfulness Myths and FAQ',
    },
    {
        id: CPProgramSharedStep.MindfulnessTipsStep,
        component: MindfulnessTipsWeekOneStep,
        tooltip: 'Mindfulness Tips',
    },
    {
        id: CPProgramWeekOneStep.MindfulnessImprovementsTopicsStep,
        component: MindfulnessImprovementsTopicsStep,
        tooltip: 'How do you want to use Mindfulness?',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CPProgramWeekOneStep.MindfulnessExerciseStep,
        component: MindfulnessExerciseStep,
        tooltip: 'Mindfulness Exercise',
        noButtons: true,
    },
];

const t = (key: string) => `cp:week-1.data.${key}`;

export const weekOneData = {
    id: ProgramWeekEnum.WeekOne,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    definition: t('definition'),
    description: t('description'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    iconUrl: meditationIcon,
    congratulationsIconUrl: supportIcon,
    weekNumber: 0,
    readableWeekNumber: 1,
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};

export const mindfulnessFAQCardsIcons = [
    undrawLostIcon,
    undrawEventsIcon,
    undrawTimeIcon,
    undrawMindfulnessIcon,
    undrawThoughtsIcon,
    undrawFocusIcon,
    undrawStudyingIcon,
];

export const mindfulnessImprovementsTopics = {
    improveWorkTopics: [
        {
            definition: 'Increase focus',
            description: 'increasing your focus',
        },
        {
            definition: 'Improve concentration',
            description: 'improving your concentration',
        },
        {
            definition: 'Mental clarity',
            description: 'enhancing your mental clarity',
        },
        {
            definition: 'Reduce stress',
            description: 'reducing your stress',
        },
        {
            definition: 'Respond with kindness',
            description: 'responding with more kindness',
        },
        {
            definition: 'More self-control',
            description: 'having more self-control',
        },
        {
            definition: 'Other',
        },
    ],
    improvePersonalLifeTopics: [
        {
            definition: 'Be more present',
            description: 'being more present',
        },
        {
            definition: 'Have more empathy',
            description: 'having more empathy',
        },
        {
            definition: 'Build self-compassion',
            description: 'enhancing your self-compassion',
        },
        {
            definition: 'Sleep better',
            description: 'sleeping better',
        },
        {
            definition: 'Be less anxious',
            description: 'being less anxious',
        },
        {
            definition: 'More self-control',
            description: 'having more self-control',
        },
        {
            definition: 'Other',
        },
    ],
};

export const initialMindfulnessImprovementsData = {
    workImprovementsTopics: [],
    lifeImprovementsTopics: [],
    lifeImprovementsAdditionalInfo: '',
    workImprovementsAdditionalInfo: '',
};

export const mindfulnessTipsCardsIcons = [undrawLostIcon, undrawMindfulnessIcon, undrawTimeIcon];
